// eslint-disable-next-line no-restricted-imports
import type { AppFlyoutAnchorState } from "@1js/acui-button/lib/Next";
import { mergeClasses } from "@fluentui/react-components";
import type { RibbonFlyoutAnchorInternalProps } from "../RibbonFlyoutAnchor";
export const useRibbonFlyoutAnchorStyles = (
  state: AppFlyoutAnchorState,
  props: RibbonFlyoutAnchorInternalProps
) => {
  state.menu.className = mergeClasses(
    props.menuClassName,
    state.menu.className
  );
  state.menuButton.className = mergeClasses(
    props.menuButtonClassName,
    state.menuButton.className,
    !state.menu.hidden && props.menuButtonExpandedClassName
  );
  return state;
};
